import { ITable } from './article-clinic.type'

const HEADER_REG_EXP = /<h1(?:\s?[^>]*?)>(?!<br)(.+?)<\/h1>/g

const formatHtml = (
  htmlContent: string,
  id: number
): [htmlContent: string, infoAboutHeaders: ITable[]] => {
  const header = htmlContent.match(HEADER_REG_EXP) || []

  const infoAboutHeaders: ITable[] = header.map((htmlEl, i) => {
    const ID = `article_${id}_${i}`
    const replacer = htmlEl.replace(
      /<h1(.*?)>/,
      `</section><section style='padding-top: 100px; margin-top: -100px' id='${ID}'><h2 $1>`
    )
    htmlContent = htmlContent.replace(htmlEl, replacer)
    return { name: htmlEl, id: ID }
  })

  return [htmlContent, infoAboutHeaders]
}

export { formatHtml }
